<template>
  <v-container fluid>
    <v-card class="pa-3">
      <v-row align="center">
        <v-col cols="12" sm="2" class="text-center">{{ $t('common.projectName') }}</v-col>
        <v-col cols="12" sm="3">
          <v-select required :items="projects" item-text="Name" item-value="Id" v-model="projectId" @change="fetchLogos()"></v-select>
        </v-col>
      </v-row>
      <v-row align="center">
        <v-col cols="12" sm="2" class="text-center">{{ $t('logos.prysmian')}}</v-col>
        <v-col cols="10" sm="2">
          <input ref="prysmianUpload" type="file" accept="image/png" hidden @change="createPrysmianLogo()" />
          <v-btn
            :disabled="projectId == null"
            elevation="1"
            block
            outlined
            class="text-none"
            color="primary"
            @click="openPrysmianDialog()"
          >{{ $t('common.chooseFile') }}</v-btn>
        </v-col>
        <v-col cols="2" sm="1">
          <v-btn :disabled="projectId == null || !prysmianLogoExists" color="primary" x-small fab outlined elevation="1" @click="deletePrysmianLogo()">
            <v-icon small color="primary">mdi-delete</v-icon>
          </v-btn>
        </v-col>
        <v-col cols="12" sm="7">
          <v-img class="vueImage" height="150" width="500">
            <img class="image" :src="prysmianImage" />
          </v-img>
        </v-col>
      </v-row>
      <v-row align="center">
        <v-col cols="12" sm="2" class="text-center">{{ $t('logos.customer')}}</v-col>
        <v-col cols="10" sm="2">
          <input ref="customerUpload" type="file" accept="image/png" hidden @change="createCustomerLogo()" />
          <v-btn
            :disabled="projectId == null"
            elevation="1"
            block
            outlined
            class="text-none"
            color="primary"
            @click="openCustomerDialog()"
          >{{ $t('common.chooseFile') }}</v-btn>
        </v-col>
        <v-col cols="2" sm="1">
          <v-btn :disabled="projectId == null || !customerLogoExists" color="primary" x-small fab outlined elevation="1" @click="deleteCustomerLogo()">
            <v-icon small color="primary">mdi-delete</v-icon>
          </v-btn>
        </v-col>
        <v-col cols="12" sm="7">
          <v-img class="vueImage" height="150" width="500">
            <img class="image" :src="customerImage" />
          </v-img>
        </v-col>
      </v-row>
    </v-card>
  </v-container>
</template>

<script>
  import { mapMutations, mapGetters, mapActions } from "vuex";

  export default {
    data() {
      return {
        projectId: null,
        prysmianImage: null,
        customerImage: null,
        noImage: "img/no-image.png",
      };
    },
    computed: {
      ...mapGetters(["m_project/getProjectNames", "m_project/getProject"]),

      selectedProject() {
        return this["m_project/getProject"];
      },
      projects() {
        return this["m_project/getProjectNames"].filter((p) => p.VCount > 0);
      },
      prysmianLogoExists() {
        return this.prysmianImage != null && this.prysmianImage != this.noImage;
      },
      customerLogoExists() {
        return this.customerImage != null && this.customerImage != this.noImage;
      },
    },
    created() {
      this["m_project/fetchProjectNames"]();
    },
    beforeRouteEnter(to, from, next) {
      next((vm) => {
        vm.mHideLongLoader();
      });
    },
    methods: {
      ...mapMutations(["mHideLongLoader"]),
      ...mapActions([
        "m_project/fetchProjectNames",
        "m_project/fetchProjectById",
        "m_project/updateProject",
      ]),
      fetchLogos() {
        this.$refs.customerUpload.value = "";
        this.$refs.prysmianUpload.value = "";
        this["m_project/fetchProjectById"]({ id: this.projectId }).then(() => {
          this.prysmianImage =
            this.selectedProject.prysmianLogo == null
              ? this.noImage
              : "data:image/png;base64," + this.selectedProject.prysmianLogo;
          this.customerImage =
            this.selectedProject.customerLogo == null
              ? this.noImage
              : "data:image/png;base64," + this.selectedProject.customerLogo;
        });
      },
      openPrysmianDialog() {
        this.$refs.prysmianUpload.click();
      },
      openCustomerDialog() {
        this.$refs.customerUpload.click();
      },
      createPrysmianLogo() {
        var logo = this.$refs.prysmianUpload.files[0];

        var reader = new FileReader();
        reader.onload = (e) => {
          this.prysmianImage = e.target.result;
          this.selectedProject.prysmianLogo = this.prysmianImage.replace(
            /data:image\/png;base64,/gi,
            ""
          );
          this["m_project/updateProject"](this.selectedProject).then(
            this.fetchLogos
          );
        };
        reader.readAsDataURL(logo);
      },
      createCustomerLogo() {
        var logoCustomer = this.$refs.customerUpload.files[0];

        var reader = new FileReader();
        reader.onload = (e) => {
          this.customerImage = e.target.result;
          this.selectedProject.customerLogo = this.customerImage.replace(
            /data:image\/png;base64,/gi,
            ""
          );
          this["m_project/updateProject"](this.selectedProject).then(
            this.fetchLogos
          );
        };
        reader.readAsDataURL(logoCustomer);
      },
      deletePrysmianLogo() {
        this.selectedProject.prysmianLogo = null;
        this["m_project/updateProject"](this.selectedProject).then(
          this.fetchLogos
        );
      },
      deleteCustomerLogo() {
        this.selectedProject.customerLogo = null;
        this["m_project/updateProject"](this.selectedProject).then(
          this.fetchLogos
        );
      },
    },
  };
</script>
<style scoped>
  .vueImage {
    vertical-align: middle;
    text-align: center;
    display: table-cell;
  }
  .image {
    max-width: 100%;
    max-height: 100%;
    display: block;
    margin: 0 auto;
  }
</style>
